import React from "react";

export default function CustomerSupportCenter() {
  return (<a className="hidden sm:block sm:visible underline underline-offset-4" target="_blank" href="">
    Customer Support Center
  </a>);
}